import { Component } from '@angular/core';

@Component({
  selector: 'app-send-info-banner',
  templateUrl: './send-info-banner.component.html',
  styleUrls: ['./send-info-banner.component.scss']
})
export class SendInfoBannerComponent {

}
